export default "__VITE_ASSET__DpLEsLd0__"